const cellphoneCompiler = (data, outputType = "withPrefix") => {
  if (!data) return data;
  if (outputType === "withPrefix") {
    return data?.startsWith("09") ? data.replace("09", "+989") : data;
  } else if (outputType === "noPrefix") {
    return data?.startsWith("+989") ? data.replace("+989", "09") : data;
  }
};
export default cellphoneCompiler;
